// Client-side geofence test for the geoGate screen. Mirrors
// amplify/backend/function/driverApi/src/lib/geo.js — the server re-runs the
// same test at check-in, so this copy is UX only, never the security boundary.
// Fences are GeoJSON Polygon/MultiPolygon; holes never occur (GeoFencePanel
// only produces simple convex polygons with draggable corners), so outer rings
// only.

/** Ray-casting test of [lng, lat] against one linear ring. */
const inRing = (point, ring) => {
  const [x, y] = point;
  let inside = false;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const [xi, yi] = ring[i];
    const [xj, yj] = ring[j];
    if ((yi > y) !== (yj > y) && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi) {
      inside = !inside;
    }
  }
  return inside;
};

/** Is [lng, lat] inside the geometry (Polygon or MultiPolygon)? */
export const pointInGeofence = (point, geometry) => {
  if (!geometry || !geometry.coordinates) return false;
  const polygons =
    geometry.type === "Polygon"
      ? [geometry.coordinates]
      : geometry.type === "MultiPolygon"
        ? geometry.coordinates
        : [];
  return polygons.some(
    (poly) => Array.isArray(poly) && Array.isArray(poly[0]) && inRing(point, poly[0]),
  );
};
